import script from "./SettingsIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__